import { FetchResourceCollectionOK } from '../types/FetchResourceCollectionOK'
import { Resource } from '../types/Resource'
import guards from '.'

export default <R extends Resource>(japiDocument: any): japiDocument is FetchResourceCollectionOK<R> => typeof japiDocument === 'object' && ! guards.isErrorDocument(japiDocument) && Array.isArray(japiDocument.data)
